<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="goToDetail"
                            @new-item="goToDetail"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:submitted_at" slot-scope="row">
                                {{row.item.submitted_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
export default {
    name: 'SafetyNonConformanceReport',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['non_conformance_report_listing']));
        return {
            tableConfig:{
                name: 'non-conformance-report-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.non_conformance_report, 'create'),
                    delete: this.$checkRole(this.$accessModule.non_conformance_report, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Contractor Supervisor Acknowledged', text: 'Contractor Supervisor Acknowledged'},
                            {value: 'PM Acknowledged', text: 'PM Acknowledged'},
                            {value: 'Completed ', text: 'Completed '},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
        }
    },
    computed: {
        // Add computed properties here
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getNonConformanceReportItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list.", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteNonConformanceReportItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'non_conformance_report'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },
        goToDetail(item = null) {
            let id = 0;
            if(item && item.id) id = item.id;
            this.$router.push(`/v2/non-conformance-report/${id}`)
        },
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
</style>